import axios from "axios";
import { DataUploadDraftSubmit } from "./types";

export const dataUploadDraftSubmit = async (props: DataUploadDraftSubmit) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/supplier/saveDetails`,
      {
        email: props.email,
        record_id: props.recordId,
        transfer_id: props.transferId,
        transfer_location: props.transferLocation,
        stdm_deliverables: props.deliverables,
        description: props.description,
        file_names: props.fileNames,
        status: props.status,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (err: any) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
